// extracted by mini-css-extract-plugin
export var actions = "_sv-4";
export var item = "_sv-1";
export var price = "_sv-3";
export var quantity = "_sv-2";
export var table = "_sv-0";